import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {NavbarRoutingModule} from './navbar-routing.module';
import { NavbarComponent } from './navbar.component';
import {LazyLoadImageModule} from 'ng-lazyload-image';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatRippleModule} from '@angular/material/core';
import { MatBottomSheetModule } from '@angular/material';
import { NgOtpInputModule } from 'ng-otp-input';
import { LottieAnimationViewModule } from 'ng-lottie';
import { FlexLayoutModule} from '@angular/flex-layout';
import { MobileSidebarComponent } from 'src/app/mobile-sidebar/mobile-sidebar.component';


@NgModule({
  declarations: [NavbarComponent,MobileSidebarComponent],
  imports: [
    CommonModule,
    LazyLoadImageModule,
    NavbarRoutingModule,
    MatMenuModule,
    MatButtonModule,
    MatRippleModule,
    MatIconModule,
    FlexLayoutModule,
    LottieAnimationViewModule.forRoot(),
    FlexLayoutModule
  //  DiwaliBannerModule
  ],
  exports:[NavbarComponent],
   schemas: [CUSTOM_ELEMENTS_SCHEMA]
  
})
export class NavbarModule { }
